import { noSpacingVariants } from 'shared/consts';

const noSpacingHelper = (alias = '', spacing = 12) => {
	return Object.values(noSpacingVariants).includes(alias) ? 0 : spacing;
};

export default noSpacingHelper;
